import {Component} from 'react'
import {Logger, useLogger} from '@kensho/lumberjack'

import Page from './components/Page'

interface ErrorBoundaryProps {
  children: React.ReactNode
  log: Logger
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo): void {
    const {log} = this.props
    this.setState({hasError: true})
    log.error(error, info)
  }

  public render(): React.ReactNode {
    const {children} = this.props
    const {hasError} = this.state
    if (!hasError) return children
    return (
      <Page useDefaultHeader={false}>
        <p>Something went wrong. Please refresh the page and try again.</p>
      </Page>
    )
  }
}

export default function ErrorBoundaryWithLogger(
  props: Omit<ErrorBoundaryProps, 'log'>,
): JSX.Element {
  const log = useLogger()
  return <ErrorBoundary {...props} log={log} />
}
